var cardItem = {
   methods: {
        getGradient(color,vals){
            if (!vals) vals = [0.2,1]
            if (!color) color = process.env.colors.primary
            return  `to bottom, rgba(${this.hexToRgb(color,vals[0])}), rgba(${this.hexToRgb(color,vals[1])})`
        },
        hexToRgb(hex,opacity) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? [
              parseInt(result[1], 16),
              parseInt(result[2], 16),
              parseInt(result[3], 16),
              parseFloat(opacity > -1 ? opacity : 1)
             ].join(',') : null;
            /*return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
              a: parseFloat(opacity || 1)
            } : null;*/
          },
          _config(type,value){
            let setting = this.$config[type]
            if (!setting || !value) return {}
            if (setting[value]) return setting[value]
            if (value.split && setting[value.split('-')[0]]) return setting[value.split('-')[0]]
            if (Array.isArray(setting)){
                return setting.filter(s=>s.value==value)[0] || {}
            }
            return setting.default || {}
        },

    }
    
  }


  export default cardItem